var exports = {
  "k": "xa15a2ab7--0f6d2a--container",
  "c": "xa15a2ab7--0f6d2a--coworking-profit-banner",
};

module.exports = exports;
